import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { withStyledTheme } from '@at/sauron-platform-core';
import { withAppContext, withHelmet } from '@at/sauron-platform-core';
import { withGraphQL } from '@at/sauron-platform-graphql';
import { withScripts } from './script.js';
import { loadableReady } from './loadable/loadable-ready.js';
const SinglePageApp = ({ children, appName: applicationName, config, graphQL = { enabled: true }, router = { enabled: true }, styledTheme = { enabled: true }, scripts = { disabledScripts: [] }, }) => {
    const App = () => router.enabled ? React.createElement(BrowserRouter, null, children) : React.createElement(React.Fragment, null, children);
    App.displayName = 'SinglePageAppWrapper';
    const appName = applicationName + (process.env.NODE_ENV === 'development' ? '-local' : '');
    const gql = Object.assign({ enabled: true }, graphQL);
    let WrappedApp = App;
    WrappedApp = styledTheme.enabled ? withStyledTheme(WrappedApp, styledTheme.extendedTheme) : WrappedApp;
    WrappedApp = gql.enabled
        ? withGraphQL(WrappedApp, Object.assign(Object.assign({ appName, batchingEnabled: gql.batchingEnabled, cache: gql.cache }, (gql.uri && { uri: gql.uri })), { appendOriginator: gql.appendOriginator }))
        : WrappedApp;
    WrappedApp = withScripts(WrappedApp, scripts.disabledScripts.map((disabledScript) => disabledScript.script));
    WrappedApp = withHelmet(WrappedApp);
    WrappedApp = withAppContext(WrappedApp, Object.assign({ appName }, config));
    return React.createElement(WrappedApp, null);
};
const bootstrap = (App, options = {}) => {
    const { loadableEnabled = true, render = ReactDOM.hydrate, rootElementId = 'root' } = options;
    if (loadableEnabled) {
        loadableReady(() => {
            render(React.createElement(App, null), document.getElementById(rootElementId));
        });
    }
    else {
        render(React.createElement(App, null), document.getElementById(rootElementId));
    }
};
export { SinglePageApp, bootstrap };
